"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AvatarGroupClippath = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = __importDefault(require("react"));
const prop_types_1 = __importDefault(require("prop-types"));
const avatar_group_svg_1 = __importDefault(require("./avatar.group.svg"));
const invisible_1 = __importDefault(require("../invisible/invisible"));
const constants_1 = require("./constants");
class AvatarGroupClippath extends react_1.default.PureComponent {
    constructor() {
        super(...arguments);
        this.render = () => {
            const points = [
                `${constants_1.AVATAR_GROUP_VIEWBOX_SIZE * 0.25},${constants_1.AVATAR_GROUP_VIEWBOX_SIZE * 0.06699}`,
                `${constants_1.AVATAR_GROUP_VIEWBOX_SIZE * 0.75},${constants_1.AVATAR_GROUP_VIEWBOX_SIZE * 0.06699}`,
                `${constants_1.AVATAR_GROUP_VIEWBOX_SIZE},${constants_1.AVATAR_GROUP_VIEWBOX_SIZE * 0.5}`,
                `${constants_1.AVATAR_GROUP_VIEWBOX_SIZE * 0.75},${constants_1.AVATAR_GROUP_VIEWBOX_SIZE * 0.93301}`,
                `${constants_1.AVATAR_GROUP_VIEWBOX_SIZE * 0.25},${constants_1.AVATAR_GROUP_VIEWBOX_SIZE * 0.93301}`,
                `0,${constants_1.AVATAR_GROUP_VIEWBOX_SIZE * 0.5}`
            ];
            return (jsx_runtime_1.jsx(invisible_1.default, { children: jsx_runtime_1.jsx(avatar_group_svg_1.default, Object.assign({ viewBox: constants_1.AVATAR_GROUP_VIEWBOX_SIZE }, { children: jsx_runtime_1.jsx("clipPath", Object.assign({ id: this.props.clipPathId }, { children: jsx_runtime_1.jsx("polygon", { points: points.join(' ') }, void 0) }), void 0) }), void 0) }, void 0));
        };
    }
}
exports.AvatarGroupClippath = AvatarGroupClippath;
AvatarGroupClippath.propTypes = {
    clipPathId: prop_types_1.default.string.isRequired
};
exports.default = AvatarGroupClippath;
//# sourceMappingURL=avatar.group.clippath.js.map